<template>
  <div class="innerBox">
    <h1>Master Data - Warna</h1>

    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter</h4>
      </template>
      <div class="row outerBox filterBox">
        <div class="col row">
          <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Cari</label>
            <input v-on:keyup.enter="vue_universal_table.update++"  type="text" class="form-control" placeholder="Ketik teks" style="height: 38px;" v-model="filter.search">
          </div>
          <div class="col-md-4" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
            <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
          </div>
        </div>
      </div>
    </panel>

    <vue-universal-table
      :api_url="'/api/v1/masterData/car/color'"
      :filter="filter"
      :fields="vue_universal_table.fields"
      :update="vue_universal_table.update"
      :sort_by="'name'"
      :sort_order="'ASC'"
    ></vue-universal-table>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        mobile : this.isMobile(),
        filter : {
          search : ''
        },
        vue_universal_table : {
          fields : [
            {
              title : "ID",
              variable : "id"
            },
            {
              title : "Nama Warna",
              variable : "name"
            }
          ],
          update : 0
        }
      }
    },
    mounted () {

    },
    methods : {

    }
  }
</script>

<style scoped>
  .pt20{
    padding-top : 20px;
  }
</style>